<script>
  import { onMount } from 'svelte';

  export let fallback = null; // Fallback content for SSR

  let mounted = false;

  onMount(() => {
    mounted = true;
  });
</script>

{#if mounted}
  <slot />
{:else if fallback}
  {fallback}
{/if}
